import React from 'react';
import { NavLink } from 'react-router-dom';
import ProfileIcon from './icons/icon_profile.svg';
import { useGlobalState } from 'store/reducers/reducer';
export const SidebarProfile = ({ menuReset }) => {
    const { state } = useGlobalState();
    return (React.createElement(NavLink, { className: "nav-link profile", "data-cy": "Profile", onClick: () => {
            if (menuReset)
                menuReset();
        }, to: "/account" },
        React.createElement("div", { className: "nav-link__items" },
            React.createElement(ProfileIcon, null),
            React.createElement("div", { className: "profile__names" },
                state.account && (React.createElement("div", { className: "account-name text-ellipsis text-weak" }, state.account.name)),
                state.user && (React.createElement("div", { className: "account-user text-ellipsis", "data-ph-mask": true },
                    state.user.firstName,
                    " ",
                    state.user.lastName))))));
};
